import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {

  transform(value: any[], by: string, isMultiLanguage: boolean = false, reverse: boolean = false) {
    return value.sort((a, b) => {
      if (isMultiLanguage) {
        if (reverse) {
          return b[by].en - a[by].en;
        } else {
          return a[by].en - b[by].en;
        }
      } else {
        if (reverse) {
          return b[by] - a[by];
        } else {
          return a[by] - b[by];
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/pipes/order-by/order-by.ts